// extracted by mini-css-extract-plugin
export default {"rateStar":"RateStar_rateStar__yUfoH","rateStarSolid":"RateStar_rateStarSolid__ewUMp","icon":"RateStar_icon__SZ-In"};